<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps({
  icon: String,
  reverse: Boolean,
  size: {
    type: String,
    required: false,
    default: 'medium',
    validitors: ['small', 'medium', 'large', 'xlarge']
  },
  badge: {
    type: Number,
    required: false,
    default: 0
  },
  grey: {
    type: Boolean,
    required: false,
    default: false
  },
  theme: {
    type: Boolean,
    required: false,
    default: false
  }
})

let mouseHover = ref(false)

let iconSize = ref(props.size || 'medium')

const badgeCom = computed(() => props.badge)

function toTextSize(size: string) {
  if (size == null || size == undefined) {
    return 'text-xl'
  }
  switch (size) {
    case 'small':
      return 'text-base'
    case 'medium':
      return 'text-xl'
    case 'large':
      return 'text-2xl'
    case 'xlarge':
      return 'text-3xl'
    default:
      return 'text-xl'
  }
}

const iconTextColor = computed(() => {
  if (props.grey) {
    return 'text-third'
  }
  if (mouseHover.value) {
    if (props.reverse) {
      return 'text-inverted'
    } else if (props.theme) {
      return 'text-theme-main'
    } else {
      return 'text-main'
    }
  } else {
    if (props.reverse) {
      return 'text-inverted'
    } else if (props.theme) {
      return 'text-theme-main'
    } else {
      return 'text-main'
    }
  }
})
</script>
<template>
  <div relative @mouseover="mouseHover = true" @mouseleave="mouseHover = false" cursor-pointer icon-button>
    <i :class="[iconTextColor, props.icon, toTextSize(iconSize), 'inline-block']" text-2xl></i>
    <div v-if="badgeCom > 0" absolute top--1 right--0.5 rounded-full px-1.5 py-0.15 text-inverted bg-red text-xs>
      {{ badgeCom }}
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
